import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=3889b754"
import script from "./search-page.vue?vue&type=script&lang=js"
export * from "./search-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports